/**
 * ListGroupHandler class provides functionality for managing list-group items.
 */
export class ListGroupHandler {
    /**
     * Sets the top position and height of the list-item--divider.
     * @param element The HTML element to calculate values for.
     */
    public static SetDividerProperties(element: HTMLElement): any {
        if (element == null) {
            return null;
        }

        // get the content, it is always added to HTML
        const contentElement = element.querySelector('.list-item__content') as HTMLElement;

        return {
            offsetTop: contentElement.offsetTop,
            offsetHeight: contentElement.offsetHeight,
        }
    }
}

window['ListGroupHandler'] = ListGroupHandler;